import { AppLinks } from '../types';

function isIosDevice(userAgent: string) {
  return /iphone|ipad|ipod/.test(userAgent);
}

function isAndroidDevice(userAgent: string) {
  return /android/.test(userAgent);
}

export function getPreferredAppLink(
  appLinks?: AppLinks,
  userAgent: string = navigator.userAgent.toLowerCase()
) {
  if (!appLinks) {
    return undefined;
  }

  if (isIosDevice(userAgent) && appLinks.appStore) {
    return appLinks.appStore;
  }

  if (isAndroidDevice(userAgent) && appLinks.playStore) {
    return appLinks.playStore;
  }

  return appLinks.playStore || appLinks.appStore;
}

export function openPreferredAppLink(
  appLinks?: AppLinks,
  userAgent: string = navigator.userAgent.toLowerCase()
) {
  const url = getPreferredAppLink(appLinks, userAgent);

  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export function getWhatsAppUrl(phone?: string) {
  if (!phone) {
    return undefined;
  }

  const cleaned = phone.replace(/\D/g, '');
  return cleaned ? `https://wa.me/${cleaned}` : undefined;
}

export function openWhatsAppChat(phone?: string) {
  const url = getWhatsAppUrl(phone);

  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

/**
 * Opens the configured sales URL, or falls back to a WhatsApp deeplink with
 * a pre-filled message. The message is passed in by the caller so it can be
 * translated (callers typically use the `whatsapp.salesMessage` i18n key
 * with the brand interpolated).
 */
export function openSalesOrWhatsApp(
  salesUrl?: string,
  whatsapp?: string,
  message?: string
) {
  if (salesUrl) {
    window.open(salesUrl, '_blank', 'noopener,noreferrer');
    return;
  }

  const cleaned = (whatsapp || '').replace(/\D/g, '');
  if (cleaned) {
    const encoded = encodeURIComponent(message || '');
    const suffix = encoded ? `?text=${encoded}` : '';
    window.open(`https://wa.me/${cleaned}${suffix}`, '_blank', 'noopener,noreferrer');
  }
}
